module.exports = __webpack_public_path__ + "static/media/boat-img-47.2ceb47bc.jpg";